import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ArticleGrid from './components/ArticleGrid';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans flex flex-col">
      <Navbar />
      <ArticleGrid />
      <Footer />
    </div>
  );
}
